<template>
  <div
    v-click-off="{ method: close }"
    class="relative"
  >
    <IconButton
      icon="more-vertical"
      :label="$t('message.menu.iconButtonLabel')"
      :active="visible"
      @click="toggle"
    />
    <transition name="transition-menu-top-right">
      <div
        v-show="visible"
        data-menu
        class="bg-white rounded border shadow absolute z-10 min-w-40"
        :class="classList"
      >
        <div data-items>
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import IconButton from '@vuedir/components/IconButton'
import clickOffDirective from '@vuedir/directives/ClickOff'

/**
 * Menu.vue
 */
export default {
  directives: {
    'click-off': clickOffDirective,
  },

  components: {
    IconButton,
  },

  props: {
    position: {
      type: String,
      default: 'top left',
      validator: (value) => ['top left', 'top right', 'bottom left', 'bottom right'].indexOf(value) !== -1,
    },
  },

  data () {
    return {
      visible: false,
    }
  },

  computed: {
    classList () {
      return [
        this.position === 'top left' ? 'top-100 left-0' : '',
        this.position === 'top right' ? 'top-100 right-0' : '',
        this.position === 'bottom left' ? 'bottom-100 left-0' : '',
        this.position === 'bottom right' ? 'bottom-100 right-0' : '',
      ]
    },
  },

  methods: {
    close () {
      this.visible = false
    },

    toggle () {
      this.visible = !this.visible
    },
  },
}
</script>
